import { Box, LineHeight500, Spacing16, FontSize75 } from '@nyshex/keel';
import styled from 'styled-components';

export const GdprContent = styled(Box)`
  font-size: ${FontSize75};
  line-height: ${LineHeight500};
  padding-bottom: ${Spacing16};
`;
